<template>
  <div class="row justify-content-center">
    <div class="col-lg-8 col-md-10 col-sm-12">
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="Profile" name="Profile">
          <Profile-Setup/>
        </el-tab-pane>
        <el-tab-pane label="Card" name="Card">
          <Payment-Card-Setup/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        activeTab: 'Profile'
      }
    },
    methods: {
      handleClick(tab, event) {
        //console.log(tab, event)
      }
    }
  }

</script>
<style>

</style>
